import {  configureStore} from '@reduxjs/toolkit';
import { authSlice } from './slices/auth/authSlice';
import { utilSlice } from './slices/util/utilSlice';
import { productSlice } from './slices/product/productSlice';
import { wishlistSlice } from './slices/wishlist/wishlistSlice';
import { orderSlice } from './slices/order/orderSlice';
import { cartSlice } from './slices/cart/cartSlice';
import { couponSlice } from './slices/coupon/couponSlice';
import { categorySlice } from './slices/categories/categorySlice';
import { colorSlice } from './slices/color/colorSlice';
import loaderSlice from './slices/loader/loaderSlice';
import { appointmentSlice } from './slices/appointment/appointmentSlice';
import { cmsSlice } from './slices/cms/cmsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    util: utilSlice.reducer,
    product: productSlice.reducer,
    wishlist: wishlistSlice.reducer,
    order: orderSlice.reducer,
    cart: cartSlice.reducer,
    coupon: couponSlice.reducer,
    category: categorySlice.reducer,
    color: colorSlice.reducer,
    loader: loaderSlice.reducer,
    appointment: appointmentSlice.reducer,
    cms: cmsSlice.reducer,
  },
});

export default store;
